import ngRouter from '@uirouter/angularjs';
import maIsohService from "../../services/maIsohService/maIsohService";
import carsServiceModule from "../../services/carsService/carsService";
import carPartsDimensionsModule from "../../services/carPartsDimensions/carPartsDimensions";
import carCategory from "../../services/category";
import welcomeWizard from './welcomeWizard';
import ngDialogModule from 'ng-dialog';
import uiMask from 'angular-ui-mask';
import uiBootstrap from 'angular-ui-bootstrap';
import * as maIsohMessages from '../../services/maIsohService/maIsohService';
import AppDirectory from 'appdirectory';
import pscDimensionsModule from "../../services/pscDimensions/pscDimensions";
import './welcomeWizard';
import notifyModule from '../../services/notificationService/notificationService';
import Raven from 'raven-js';
import moment from 'moment/moment';
import appName from '../../appName';
import updateServiceModule from "../../services/updateService/updateService";
import ngSanitize from "angular-sanitize";
import carsService from "../../services/carsService/carsService";


const MAX_IMAGE_SIZE = 250000;

export default angular.module('home', [
	ngRouter,
	'base64',
	maIsohService,
	updateServiceModule,
	'ui-notification',
	carsServiceModule,
	'mwl.confirm',
	'cfp.hotkeys',
	ngDialogModule,
	uiMask,
	'multipleSelect',
	carPartsDimensionsModule,
	carCategory,
	uiBootstrap,
	pscDimensionsModule,
	welcomeWizard,
	notifyModule,
	ngSanitize
]).config(($stateProvider) => {
	$stateProvider.state({
		name: 'autovraky.home',
		url: 'home',
		templateUrl: 'modules/home/home.tpl.html'
	});
}).controller('HomeController', function($scope,
										 maIsoh, notify, carsService, hotkeys, ngDialog, carDimensions, carPartsDimensions, userService, $timeout, $log, $state) {

	this.selectedCar = [];
	let now = new Date();

	this.appName = appName;

	this.filter = {
		others: true,
		selected: true,
		selectedNonsend: true,
		canceled: true,
		month: 'all',
		year: now.getFullYear()
	};

	/**
	 * Options for month filter
	 * @type {*[]}
	 */
	this.monthOptions = [
		{value: '1', name: 'Leden'},
		{value: '2', name: 'Únor'},
		{value: '3', name: 'Březen'},
		{value: '4', name: 'Duben'},
		{value: '5', name: 'Květen'},
		{value: '6', name: 'Červen'},
		{value: '7', name: 'Červenec'},
		{value: '8', name: 'Srpen'},
		{value: '9', name: 'Září'},
		{value: '10', name: 'Říjen'},
		{value: '11', name: 'Listopad'},
		{value: '12', name: 'Prosinec'},
		{value: 'all', name: 'Zobrazit vše'},
		{value: 'year', name: 'Celý rok'}
	];

	this.filterCars = () => {
		this.filteredCars = this.cars.filter((car) => {
			let date = moment(car.datumPrijeti, 'DD.MM.YYYY');

			if (!this.filter.canceled && car.datumStorna && car.datumStorna.length > 0) {
				return false;
			}

			if (this.filter.month == 'year') {
				if (date.year() != this.filter.year) {
					return false;
				}
			}

			if (this.filter.month !== 'all' && this.filter.month !== 'year' && ((date.month() + 1) != this.filter.month || date.year() != this.filter.year)) {
				return false;
			}

			if (this.filter.others && car.kategorie == 4) {
				return true;
			}

			if (this.filter.selected && car.kategorie != 4 && car.uid && car.uid.length > 0) { // meaning its 1, 2 or 3
				return true;
			}

			if (this.filter.selectedNonsend && car.kategorie != 4 && (!car.uid || car.uid.length == 0)) { // meaning its 1, 2 or 3
				return true;
			}

			if (this.filter.canceled && car.datumStorna && car.datumStorna.length > 0) {
				return true;
			}

			return false;
		});
	};

	this.loadCars = () => {
		// sort cars by number of invoice DESC
		this.cars = carsService.getCars();

		if (angular.isArray(this.cars)) {
			this.cars = this.cars.sort((a, b) => b.cisloDokladu - a.cisloDokladu);

			//get unsynced cars to MA ISOH
			this.unsyncedCars = this.cars.filter((car) => !car.uid || (car.uid && car.uid.length == 0));

			//if user dont want to send other cars
			let dontSendOtherCars = userService.getAppSettings().dontSendOtherCars;
			if (angular.isDefined(dontSendOtherCars) && dontSendOtherCars) {
				this.unsyncedCars = this.unsyncedCars.filter((car) => car.kategorie != 4);
			}
		}

		this.filterCars();
	};

	this.loadCars();

	/**
	 * Loads cars from MA ISOH
	 */
	this.loadCarsFromISOH = () => {
		notify.info('Načítám autovraky z MA ISOH, strpení prosím');
		carsService.loadCars().then(() => {
			this.loadCars();
			notify.success('Úspěch, načteno ' + this.cars.length + ' autovraků');
		}).catch((error) => {
			notify.error(error);
		});
	};

	$scope.$on('loadCarsFromISOH', () => {
		this.loadCars();
	});

	/**
	 * Loads one car from MA ISOH
	 * @param car
	 */
	this.loadCarFromISOH = (car) => {
		this.loadCarsFromISOH();
		// API expects both values - predalIc and predalDatNarozeni, which is not possible.
		// until somebody changes api, we update all cars -> hotfix, so no error will occur
		/*
		notify.info('Načítám autovrak z MA ISOH, strpení prosím');
		carsService.loadCar(car).then((car) => {
			this.loadCars();
			notify.success('Úspěšně aktualizován autovrak');
		}).catch((error) => {
			notify.error(error);
		});
		*/
	};

	/**
	 * Testing thing for Patrik
	 */
	this.testCar = () => {
		let car = {
			"cisloDokladu": 3,
			"datumPrijeti": "21.02.2017",
			"osobaPrijala": "Testovaci Patrik",
			"cisloTp": "12345",
			"registracniZnacka": "OMG1234",
			"rokVyroby": 1988,
			"rokRegistraceCr": 1988,
			"kategorie": 1,
			"znackaKod": "CRAYFORD",
			"model": "typ",
			"barva": "barvicka",
			"vin": "12487SDFWEFSDFFFD",
			"hmotnost": "3.200",
			"weightType": 0.04,
			"weightTypeValue": "3.500",
			"hmotnostDleTP": "3.460",
			"bezCasti": "KOLA,MOTOR,VYFUK,KAPOTA",
			"predalDatumNarozeni": "2016-07-05T22:00:00.000Z",
			"predalCisloDokladuTotoznosti": "123123123",
			"predalNazev": "Patrik Testovaci",
			"predalObec": "Skorkov",
			"predalZuj": 557030,
			"predalUlice": "ulice",
			"predalPsc": 28401,
			"znacka": "CRAYFORD"
		};

		car.cisloDokladu = userService.getPcp() + 1;
		car.registracniZnacka = 'OMG' + Math.floor((Math.random() * 9999) + 1000);
		car.vin = Math.floor((Math.random() * 9999) + 1000) + '7SDFWEFSDFFFD';

		carsService.addCar(car);
		this.loadCars();
		// this.sendCar(car);
	};

	/**
	 * Removes field from car object
	 * @param car
	 * @param field
	 * @returns {*}
	 */
	this.removeUnneededField = (car, field) => {
		if (angular.isDefined(car[field]) && (car[field] === null || car[field].length === 0 || isNaN(car[field]))) {
			delete car[field];
		}

		return car;
	};

	/**
	 * Send car to MA ISOH
	 * @param car
	 * @param silent dont display notify message
	 */
	this.sendCar = (car, silent = false) => {
		if (angular.isUndefined(car.predalZuj) || car.predalZuj.length == 0) {
			car.predalZuj = ''; //because MA ISOH...
		}
		if (angular.isUndefined(car.predalIc) || car.predalIc === '') {
			if(angular.isDefined(car.predalIco)) {
				car.predalIc = car.predalIco; // server expects in INSERT to have `predalIc` but in GET it returns `predalIco`...
			}
		}
		if (car.hmotnostDleTP === null || car.hmotnostDleTP === 'undefined') {
			car.hmotnostDleTP = '';
		}
		if (car.predalDatumNarozeni) {
			delete car.predalDatumNarozeni;
		}
		notify.info('Odesílám autovrak do MA ISOH');

		// /**
		//  * Remove unused fields, that gets propagated back from MA ISOH
		//  */
		// let badFields = ['predalPsc', 'barva', 'model', 'cisloTp', 'predalZeme'];
		// for (let field of badFields) {
		// 	car = this.removeUnneededField(car, field);
		// }

		return maIsoh.sendCar(car, userService.getUserSettings(), car.osobaPrijala).then((result) => {
			car.uid = result.json.UID;
			car.datumPrijeti = result.json.datumPrijeti;
			car.souhlasKraj = result.json.souhlasKraj;
			car.souhlasCJ = result.json.souhlasCJ;
			carsService.updateCar(car);
			this.loadCars();

			if (!silent) {
				notify.success('Autovrak úspěšně uložen');
				Raven.captureMessage('Autovrak uspesne ulozen', {
					level: 'info'
				});

				let message;

				//message from MA ISOH
				if (angular.isDefined(result.json.serviceStatus.item) && angular.isDefined(result.json.serviceStatus.item.find)) {
					message = result.json.serviceStatus.item.find((item) => item.statusCode == 212 || item.statusCode == 213 || item.statusCode == 312 || item.statusCode == 315);
					//212 negativni, 213 pozitivni lustrace, 312 a 315 nejede PCR lustrace

					if (!message) {
						message = result.json.serviceStatus.item[1]; //we dont have any cool message, so just display first one
					}
				} else {
					message = result.json.serviceStatus.item;
				}

				this.carSentSuccessfully([{car: car, message: message}]); //must be an array
			}

			return {car: car, message: result.json.serviceStatus.item[1]};
		}).catch((error) => {
			notify.error('Autovrak ' + ((angular.isDefined(car.registracniZnacka) && car.registracniZnacka.length > 0) ? car.registracniZnacka : '') + ', PČP ' + car.cisloDokladu + ' -> Chyba při uložení, MA ISOH hlásí: ' + error.message);
			Raven.captureMessage('Autovrak ' + car.registracniZnacka + ', PČP ' + car.cisloDokladu + ' se NEULOZIL', {
				level: 'error',
				tags: {'moc_pruser': 'hodne'},
				extra: {error: error, car: car}
			});
		});
	};

	/**
	 * Send cars sequentially, because otherwise MA ISOH starts to deadlock things
	 * @param cars
	 * @returns {Promise.<Array>}
	 */
	this.sendCarsSequentially = (cars) => {
		let result = Promise.resolve();
		let messages = [];
		cars.forEach((car) => {
			result = result.then((message) => {
				if (angular.isDefined(message)) {
					messages.push(message);
				}

				return this.sendCar(car, true);
			});
		});
		return result.then((message) => {
			messages.push(message);
		}).then(() => messages);
	};

	this.updateHmotnost = (car) => {
		maIsoh.updateHmotnost(car.uid);
	};

	/**
	 * Send all unsynced cars to MA ISOH
	 */
	this.sendCarsToISOH = () => {
		this.loadCars();
		if (this.unsyncedCars.length > 0) {
			let unsyncedCarsCount = this.unsyncedCars.length;
			notify.info('Odesílám ' + unsyncedCarsCount + ' autovraků do MA ISOH, vyčkejte prosím, tato akce může chvilku trvat');
			this.sendCarsSequentially(this.unsyncedCars).then((result) => {
				this.carSentSuccessfully(result);
				notify.success('Hotovo! Zpracováno ' + unsyncedCarsCount + ' autovraků');
				this.loadCars();
			});
		} else {
			notify.info('V programu nejsou žádné autovraky, které mohou být odeslány do MA ISOH');
		}
	};

	/**
	 * Send photos to MA ISOH
	 * @param car
	 */
	this.sendPhotos = (car) => {
		let date = new Date();


		let blobToBase64 = function(blob, cb) {
			var reader = new FileReader();
			reader.onload = function() {
				var dataUrl = reader.result;
				var base64 = dataUrl.split(',')[1];
				cb(base64);
			};
			reader.readAsDataURL(blob);
		};

		if (angular.isDefined(car.fotoVIN && !car.fotoVINOdeslano)) {
			let photo = carsService.b64toBlob(car.fotoVIN.split(',')[1]); //because it starts with "data:image/jpeg;base64,/9j/"
			blobToBase64(photo, (b64) => {
				maIsoh.sendPhotos(car.uid, maIsohMessages.AutovrakFotoUploadMsg.PHOTO_VIN, b64).then(() => {
					car.fotoVINOdeslano = date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();
					carsService.updateCar(car);

					notify.success('Fotografie VIN úspěšně nahrána');
				}).catch((e) => {
					notify.error('Fotografie VIN - ' + e.message);

					Raven.captureMessage('Autovrak ' + car.registracniZnacka + ', PČP ' + car.cisloDokladu + ' foto VIN se NENAHRALA', {
						level: 'error',
						tags: {'moc_pruser': 'hodne'},
						extra: {error: e, car: car}
					});
				});
			});

		}

		/**
		 * Because MA ISOH is locking row for car wreck, we need to wait
		 */
		$timeout(() => {
			if (angular.isDefined(car.fotoInterier) && !car.fotoInterierOdeslano) {
				let photo = carsService.b64toBlob(car.fotoInterier.split(',')[1]); //because it starts with "data:image/jpeg;base64,/9j/"
				blobToBase64(photo, (b64) => {
					maIsoh.sendPhotos(car.uid, maIsohMessages.AutovrakFotoUploadMsg.PHOTO_INSIDE, b64).then(() => {
						car.fotoInterierOdeslano = date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();
						carsService.updateCar(car);
						notify.success('Fotografie interiéru úspěšně nahrána');
					}).catch((e) => {
						notify.error('Fotografie interiéru - ' + e.message);

						Raven.captureMessage('Autovrak ' + car.registracniZnacka + ', PČP ' + car.cisloDokladu + ' foto INTERIERU se NENAHRALA', {
							level: 'error',
							tags: {'moc_pruser': 'hodne'},
							extra: {error: e, car: car}
						});
					});
				});
			}
		}, 1000); //because why not ...

		$timeout(() => {
			if (angular.isDefined(car.fotoExterier) && !car.fotoExterierOdeslano) {
				let photo = carsService.b64toBlob(car.fotoExterier.split(',')[1]); //because it starts with "data:image/jpeg;base64,/9j/"
				blobToBase64(photo, (b64) => {
					maIsoh.sendPhotos(car.uid, maIsohMessages.AutovrakFotoUploadMsg.PHOTO_OUTSIDE, b64).then(() => {
						car.fotoExterierOdeslano = date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();
						carsService.updateCar(car);
						notify.success('Fotografie exteriéru úspěšně nahrána');
					}).catch((e) => {
						notify.error('Fotografie exteriéru - ' + e.message);

						Raven.captureMessage('Autovrak ' + car.registracniZnacka + ', PČP ' + car.cisloDokladu + ' foto EXTERIERU se NENAHRALA', {
							level: 'error',
							tags: {'moc_pruser': 'hodne'},
							extra: {error: e, car: car}
						});
					});
				});
			}
		}, 2000);

		this.loadCars();
	};

	/**
	 * Processes car before saving it to DB
	 * @param car
	 * @returns {*}
	 */
	this.processCar = (car) => {
		/**
		 * Lets give the car some loooove
		 */
		let znacka = carDimensions.getDimensions().filter((item) => {
			return item.kod == car.znackaKod;
		});

		//find car type in dimension, if not found, just copy the value
		// if (znacka.length > 0) {
		// 	car.znacka = znacka[0].nazev;
		// } else {
		car.znacka = car.znackaKod;
		// }

		// format the date
		let date = moment(car.datumPrijeti);
		car.datumPrijeti = date.format('DD.MM.YYYY').toString();
		car.datumPrijetiDate = date.toDate();

		if (angular.isDefined(car.predalDatumNarozeni)) {
			date = moment(car.predalDatumNarozeni);
			car.predalDatumNarozeni = date.format('DD.MM.YYYY').toString(); //date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();
		}

		if (angular.isArray(car.bezCasti) && car.bezCasti.length > 0) {
			car.bezCasti = car.bezCasti.map((item) => item.kod).join(',');
		}

		car.hmotnost = car.hmotnost.replace(',', '.');
		if(car.hmotnostDleTP) {
			car.hmotnostDleTP = car.hmotnostDleTP.replace(',', '.');
		}

		Raven.captureMessage('Zpracoval jsem auto', {
			level: 'info',
			extra: car
		});

		return car;
	};

	this.carDetail = () => {
		ngDialog.open({
			template: 'modules/home/carModal.tpl.html',
			controller: 'CarController',
			controllerAs: 'ctrl',
			name: 'addCarDialog',
			closeByEscape: false,
			closeByNavigation: false,
			closeByDocument: false,
			width: '75%',
			data: {
				car: this.selectedCar[0],
				originPcp: angular.copy(this.selectedCar[0].cisloDokladu)
			}
		}).closePromise.then((response) => {
			if (response.value && response.value != '$closeButton') {
				let car = this.processCar(response.value);
				carsService.updateCar(car, this.selectedCar[0]);
				this.loadCars();
			}
		});
	};

	/**
	 * Opens modal for adding the car
	 */
	this.addCar = () => {
		ngDialog.open({
			template: 'modules/home/carModal.tpl.html',
			controller: 'CarController',
			controllerAs: 'ctrl',
			name: 'addCarDialog',
			closeByEscape: false,
			closeByNavigation: false,
			closeByDocument: false,
			width: '75%'
		}).closePromise.then((response) => {
			if (response.value && response.value != '$closeButton') {
				let car = this.processCar(response.value);
				carsService.addCar(car);
				userService.setReceivingUser(car.osobaPrijala);

				this.loadCars();
			}
		});
	};

	/**
	 * Opens modal for adding the photos
	 */
	this.addPhotos = () => {
		ngDialog.open({
			template: 'modules/home/photoModalWeb.tpl.html',
			controller: 'PhotoController',
			controllerAs: 'ctrl',
			name: 'addPhotoDialog',
			closeByNavigation: false,
			closeByDocument: false,
			width: '75%',
			data: {
				car: this.selectedCar[0]
			}
		}).closePromise.then((response) => {
			if (response.value && response.value != '$closeButton') {
				carsService.addPhotos(this.selectedCar[0], response.value);
				this.loadCars();
				notify.success('Fotografie přidány');
			}
		});
	};

	/**
	 * Event for saving car
	 */
	$scope.$on('savePhotos', (event, data) => {
		carsService.addPhotos(data.car, data.photos);
		$timeout(() => {
			this.loadCars();
		});
	});

	/**
	 * Display modal
	 * @param message
	 */
	this.carSentSuccessfully = (messages) => {
		ngDialog.open({
			template: 'modules/home/carResultModal.tpl.html',
			controller: 'CarResultController',
			controllerAs: 'ctrl',
			name: 'carResultDialog',
			closeByEscape: false,
			closeByNavigation: false,
			closeByDocument: false,
			showClose: false,
			width: '75%',
			data: {
				messages: messages
			}
		}).closePromise.then(() => {
			Raven.captureMessage('Uzivatel potvrdil dialog autovraku',
				{
					level: 'info',
					extra: {
						cars: messages.reduce((all, value) => all + value.car.registracniZnacka + ' [' + value.car.cisloDokladu + '], ', '')
					}
				});
		});
	};

	/**
	 * Deletes a car from DB
	 * @param car
	 */
	this.deleteCar = (car) => {
		carsService.deleteCar(car).then((result) => {
			notify.success('Autovrak úspěšně ' + ((result == 'deleted') ? 'smazán' : 'stornován'));
			this.loadCars();
		}).catch((e) => {
			notify.error(e);
		});
	};

	/**
	 * Is car canceled?
	 * @param car
	 */
	this.isCanceled = (car) => angular.isDefined(car.datumStorna) && car.datumStorna.length > 0;

	/**
	 * Is car in MA ISOH?
	 * @param car
	 */
	this.isSent = (car) => angular.isDefined(car) && angular.isDefined(car.uid) && car.uid.length > 0;

	/**
	 * Count uploaded photos
	 * @param car
	 * @returns {number}
	 */
	this.sentPhotoCount = (car) => {
		let count = 0;
		if (angular.isDefined(car.fotoVINOdeslano) && car.fotoVINOdeslano.length > 0) {
			count++;
		}
		if (angular.isDefined(car.fotoInterierOdeslano) && car.fotoInterierOdeslano.length > 0) {
			count++;
		}
		if (angular.isDefined(car.fotoExterierOdeslano) && car.fotoExterierOdeslano.length > 0) {
			count++;
		}

		return count;
	};

	/**
	 * Count local photos
	 * @param car
	 * @returns {number}
	 */
	this.localPhotoCount = (car) => {
		let count = 0;

		if (angular.isDefined(car.fotoVIN) && car.fotoVIN !== null && car.fotoVIN.length > 0 && (angular.isUndefined(car.fotoVINOdeslano) || !car.fotoVINOdeslano.length)) {
			count++;
		}
		if (angular.isDefined(car.fotoInterier) && car.fotoInterier !== null && car.fotoInterier.length > 0 && (angular.isUndefined(car.fotoInterierOdeslano) || !car.fotoInterierOdeslano)) {
			count++;
		}
		if (angular.isDefined(car.fotoExterier) && car.fotoExterier !== null && car.fotoExterier.length > 0 && (angular.isUndefined(car.fotoExterierOdeslano) || !car.fotoExterierOdeslano)) {
			count++;
		}

		// if(angular.isDefined(car.fotoVIN) && car.fotoVIN !== null && (car.fotoVIN instanceof Blob || car.fotoVIN instanceof Object)) count++;
		// if(angular.isDefined(car.fotoInterier) && car.fotoInterier !== null && (car.fotoInterier instanceof Blob || car.fotoInterier instanceof Object)) count++;
		// if(angular.isDefined(car.fotoExterier) && car.fotoExterier !== null && (car.fotoExterier instanceof Blob || car.fotoExterier instanceof Object)) count++;

		return count;
	};

	this.printCar = (car) => {


		window.open('app.html#/print/' + car.cisloDokladu, "_blank");

		// window.openDevTools();
	};

	/**
	 * Hotkeys part
	 */
	hotkeys.bindTo($scope).add({
		combo: 'f4',
		description: 'Zobrazí detail autovraku',
		callback: () => {
			if (this.selectedCar.length > 0) {
				this.carDetail(this.selectedCar[0]);
			} else {
				notify.info('Nemáte zvolený žádný autovrak, vyberte ho kliknutím v tabulce');
			}
		}
	});

	hotkeys.bindTo($scope).add({
		combo: 'f8',
		description: 'Odešle autovrak do MA ISOH',
		callback: () => {
			if (this.selectedCar.length > 0) {
				this.sendCar(this.selectedCar[0]);
			} else {
				notify.info('Nemáte zvolený žádný autovrak, vyberte ho kliknutím v tabulce');
			}
		}
	});

	hotkeys.bindTo($scope).add({
		combo: 'ins',
		description: 'Vložení nového autovraku',
		callback: () => {
			this.addCar();
		}
	});

	hotkeys.bindTo($scope).add({
		combo: 'del',
		description: 'Smazání vybraného autovraku',
		callback: () => {
			if (this.selectedCar.length > 0) {
				this.deleteCar(this.selectedCar[0]);
			} else {
				notify.info('Nemáte zvolený žádný autovrak, vyberte ho kliknutím v tabulce');
			}
		}
	});
}).controller('CarController', function($scope, hotkeys, carPartsDimensions, carCategories, userService, carsService, notify, $filter, $log, zujDimensions) {
	/**
	 * Car weights type
	 * @type {*[]}
	 */
	this.weightTypes = [{name: 'Pohotovostní hmotnost', value: 0.040}, {name: 'Provozní hmotnost', value: 0.115}];
	this.inputWarnings = [];

	$scope.altInputFormats = [
		'dd.MM.yyyy'
	];

	this.datePickerOptions = {
		'maxDate': new Date()
	};

	this.carPartsDimensions = carPartsDimensions.getDimensions().filter((item) => (item.zobraz == '1'));
	this.carCategories = carCategories;

	/**
	 * Is car editable?
	 */
	this.isEditable = () => !(angular.isDefined($scope.ngDialogData) && angular.isDefined(this.car.uid));

	/**
	 * Is car already sent?
	 */
	this.isInISOH = () => angular.isDefined(this.car.uid) && this.car.uid.length > 0;

	if (angular.isDefined($scope.ngDialogData) && angular.isDefined($scope.ngDialogData.car)) {
		this.newCar = false;
		this.car = angular.copy($scope.ngDialogData.car);
		this.originalCisloDokladu = this.car.cisloDokladu;

		this.car.datumPrijeti = moment(this.car.datumPrijeti, 'DD.MM.YYYY HH:ii:ss').toDate();
		if (angular.isDefined(this.car.predalDatumNarozeni)) {
			this.car.predalDatumNarozeni = moment(this.car.predalDatumNarozeni, 'DD.MM.YYYY').toDate();
		}

		if (angular.isDefined(this.car.predalIco) && this.car.predalIco > 0) {
			this.handlerType = 'company';
		} else {
			this.handlerType = 'guy';
		}

		let parts = [];
		if (angular.isDefined(this.car.bezCasti) && !angular.isArray(this.car.bezCasti) && this.car.bezCasti.length > 0) {
			this.car.bezCasti = this.car.bezCasti.split(',').forEach((part) => {
				let item = carPartsDimensions.getItemByCode(part);
				if (item !== null) {
					parts.push(item);
				}
			});
		}

		this.car.bezCasti = parts;

		/**
		 */
		// if (this.isInISOH()) {
		// 	let zuj = zujDimensions.findByZUJ(this.car.predalZuj);
		// }
	} else {
		this.newCar = true;
		this.car = {};
		this.handlerType = 'guy';

		// update number of invoice for new car
		this.car.cisloDokladu = userService.getPcp() + 1;

		// default value
		//this.car.kategorie = carCategories[0].value;

		// default value
		this.car.datumPrijeti = new Date();

		// default value
		this.car.osobaPrijala = userService.getUserSettings().receivingUser;
	}


	this.carForm = {};

	this.close = () => {
		$scope.closeThisDialog(false);
	};

	/**
	 * Default value for no VIN cars
	 */
	this.noVINGiven = () => {
		this.car.vin = 'bezVIN';
	};

	const WINDOWS_1250_CHAR_CODES = [
		0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,
		17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
		32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46,
		47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61,
		62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76,
		77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91,
		92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105,
		106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118,
		119, 120, 121, 122, 123, 124, 125, 126, 127, 160, 164, 166, 167,
		168, 169, 171, 172, 173, 174, 176, 177, 180, 181, 182, 183, 184,
		187, 193, 194, 196, 199, 201, 203, 205, 206, 211, 212, 214, 215,
		218, 220, 221, 223, 225, 226, 228, 231, 233, 235, 237, 238, 243,
		244, 246, 247, 250, 252, 253, 258, 259, 260, 261, 262, 263, 268,
		269, 270, 271, 272, 273, 280, 281, 282, 283, 313, 314, 317, 318,
		321, 322, 323, 324, 327, 328, 336, 337, 340, 341, 344, 345, 346,
		347, 350, 351, 352, 353, 354, 355, 356, 357, 366, 367, 368, 369,
		377, 378, 379, 380, 381, 382, 711, 728, 729, 731, 733, 8211, 8212,
		8216, 8217, 8218, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8249, 8250, 8364, 8482
	];

	this.windows1250EncodingValidator = (input, value) => {
		if (!value) {
			this.inputWarnings[input] = true;
			return;
		}

		for (let i = 0; i < value.length; i++) {
			const charCode = value.charCodeAt(i);
			if (!WINDOWS_1250_CHAR_CODES.includes(charCode)) {
				this.inputWarnings[input] = false;
				return;
			}
		}

		this.inputWarnings[input] = true;
	}

	/**
	 * Computes weight of car according to given weight type
	 */
	this.computeNewWeight = () => {
		if (angular.isDefined(this.car.weightType) && angular.isDefined(this.car.weightTypeValue)) {
			this.car.weightTypeValue = this.car.weightTypeValue.replace(',', '.');
			this.car.hmotnostDleTP = ($filter('number')(this.car.weightTypeValue - this.car.weightType, 3)).replace(',', '.').replace(' ', '');

			if (angular.isDefined(this.car.hmotnost)) {
				this.car.hmotnost = this.car.hmotnost.replace(',', '.').replace(' ', '');
			}

			this.car.weightTypeValue = ($filter('number')(parseFloat(this.car.weightTypeValue), 3)).replace(',', '.').replace(' ', '');
		}
	};

	this.removePart = (index) => {
		this.car.bezCasti.splice(index, 1);
	};

	/**
	 * Just mirror selected PSC to Obec field
	 * @param value
	 */
	this.pscSelected = (value) => {
		//THEY DONT WANT IT!
		//this.car.predalObec = value.obec;
	};

	/**
	 * Fill in name of municipality from ZUJ to other fields
	 * @param value
	 */
	this.zujSelected = (value) => {
		this.car.predalObec = value.nazev;
	};

	this.onCarCategoryChange = () => {
		//if category is 'Ostatni', null 'Hmotnost dle TP'
		if(this.car.kategorie === 4) {
			this.car.weightTypeValue = null;
			this.car.hmotnostDleTP = null;
		}
	};

	/**
	 * Close dialog and save the car
	 * @param form
	 */
	this.save = (form) => {
		if(Object.values(this.inputWarnings).includes(false)) {
			notify.error('Některý ze vstupů obsahuje nepovolené znaky');
			return;
		}

		let userSetting = userService.getUserSettings();
		userSetting.receivingUser = this.car.osobaPrijala;
		userService.setUserSettings(userSetting);

		if (angular.isDefined(this.car.vin) && this.car.vin.length == 18) {
			let conf = confirm("VIN má 18 znaků, opravdu si přejete formulář odeslat?");
			if (!conf) {
				return;
			}
		}

		if (this.newCar && carsService.pcpExists(this.car.cisloDokladu)) {
			notify.error('Toto PČP již v aplikaci existuje');
		} else if (!this.newCar && carsService.pcpExists(this.car.cisloDokladu) && this.originalCisloDokladu != this.car.cisloDokladu) {
			notify.error('Toto PČP již v aplikaci existuje');
		} else if (this.car.kategorie == 4 && this.car.hmotnostDleTP > 500) {
			notify.error('Autovrak z kategorie ostatní nesmí mít váhu vyšší než 500t');
		} else if (this.car.kategorie == 1 && (this.car.hmotnost > 5 || this.car.hmotnostDleTP > 5)) {
			notify.error('Autovrak z této kategorie nesmí mít váhu vyšší než 5t');
		} else {
			if (form.$valid && angular.isDefined(this.car)) {
				$scope.closeThisDialog(this.car);
			} else {
				notify.error('Vyplňte prosím všechna povinná pole. Správně vyplněné pole je označeno zelenou barvou. Žlutá pole jsou povinná, bílá nepovinná');
			}
		}
	};

	$scope.$watch(() => {
		return this.car.hmotnost;
	}, (val) => {
		if (angular.isDefined(val) && val.length > 0) {
			val = val.replace(',', '.');
			this.car.hmotnost = $filter('number')(parseFloat(val), 3);
			this.car.hmotnost = this.car.hmotnost.replace(',', '.');
		}
	});

	/**
	 * Hotkeys part
	 */
}).controller('PhotoController', function($scope, hotkeys, notify,
										  $timeout, $rootScope) {
	this.photoForm = {};

	this.car = angular.copy($scope.ngDialogData.car);

	if (this.car.fotoVIN) {
		this.photoForm.vin = [this.car.fotoVIN];
	}

	if (this.car.fotoInterier) {
		this.photoForm.inside = [this.car.fotoInterier];
	}

	if (this.car.fotoExterier) {
		this.photoForm.outside = [this.car.fotoExterier];
	}

	let dir = 'car-images';

	let reduceImageAndSave = function(file, dest, size = 1000) {


		return dest;
	};

	let photoTypes = {1: "inside", 2: "vin", 3: "outside"};

	/**
	 * Close dialog and save the photos
	 */
	this.save = (form) => {

		let car = {};
		let date = new Date();
		let time = date.getTime();

		for (let i in photoTypes) {

			// Access selected file
			let filesToUpload = document.getElementById('upPhoto' + i).files;
			let file = filesToUpload[0];

			if (angular.isUndefined(file)) {
				continue;
			}

			let reader = new FileReader();

			// this will be called later
			reader.onload = (e) => {
				// Read image
				let img = document.createElement("img");
				let canvas = document.createElement("canvas");
				img.src = e.target.result;
				img.onload = () => {
					scaleImage(img, 1000, 1000);
				};

				const scaleImage = (img, MAX_WIDTH, MAX_HEIGHT) => {
					let ctx = canvas.getContext("2d");
					ctx.drawImage(img, 0, 0);

					let width = img.width;
					let height = img.height;

					if (width > height) {
						if (width > MAX_WIDTH) {
							height *= MAX_WIDTH / width;
							width = MAX_WIDTH;
						}
					} else {
						if (height > MAX_HEIGHT) {
							width *= MAX_HEIGHT / height;
							height = MAX_HEIGHT;
						}
					}
					canvas.width = width;
					canvas.height = height;

					ctx = canvas.getContext("2d");
					ctx.drawImage(img, 0, 0, width, height);

					canvas.toBlob((blob) => {
						car[photoTypes[i]] = blob;
						$scope.closeThisDialog(car);
						$rootScope.$broadcast('savePhotos', {car: this.car, photos: car});
					}, 'image/jpeg', 0.60);

					return canvas;
				};
			};

			if (angular.isObject(file) && file !== null) {
				// And call onload /\
				reader.readAsDataURL(file);
			}

		}

	};

	this.close = () => {
		$scope.closeThisDialog(false);
	};

	this.selectFile = (where) => {
		let path = dialog.showOpenDialog({
			properties: ['openFile']
		});

		if (angular.isDefined(path)) {
			this.photoForm[where] = path;
		}
	};

	/**
	 * Hotkeys part
	 */
}).controller('CarResultController', function($scope) {
	this.messages = $scope.ngDialogData.messages;

	if (!angular.isArray(this.messages)) {
		this.messages = [this.messages];
	}

	this.close = () => {
		$scope.closeThisDialog(false);
	};
}).filter("translateCategory", function() {
	return function(fieldValueUnused, item) {
		switch (item.kategorie) {
			case 1:
				return 'M1';
			case 2:
				return 'N1';
			case 3:
				return 'Tříkol. voz';
			case 4:
				return 'Ostatní';
		}
	};
}).directive('imageLoad', ['$parse', function($parse) {
	return {
		restrict: 'A',
		link: function(scope, elem, attrs) {
			let fn = $parse(attrs.imageLoad);
			elem.on('load', function(event) {
				scope.$apply(function() {
					fn(scope, {$event: event});
				});
			});
		}
	};
}]).name;



// WEBPACK FOOTER //
// build/modules/home/home.js